module.exports = __webpack_public_path__ + "static/media/notice_content_1.aa4e8ca4.png";